'use client';
import CategoryGrid, { GridType } from '@components/shared/CategoryGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { memo } from 'react';
import GridItem from './_AmbassadorsGridItem';
import axios from 'axios';
import Section from '@repo/ui/src/components/Section';

const AmbassadorsGrid = ({ title, pluralType, _data }) => {
  const { locale } = useCurrentUrl();
  const ambassadorFilter = { authorType: 'Ambassador' };

  const loadData = async ({ page }, controller) => {
    return await axios.get('/api/authors/searchAuthors', {
      params: {
        page,
        filters: ambassadorFilter,
        lang: locale,
      },
      signal: controller.signal,
    });
  };

  return (
    <Section gutterX basePadding white>
      {title && <h2 className="tra-text-web-heading-2">{title}</h2>}
      <p className="md:tw-flex md:tw-justify-end tra-text-web-body-xl tw-pr-6">
        {_data?.nbHits || 0} {pluralType || 'Ambassadors'}
      </p>
      <CategoryGrid
        _data={_data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.Ambassador}
        gridCardOverrides={{ xs: 12, md: 3 }}
        disableBorder
        className="tw-bg-white"
      />
    </Section>
  );
};

export default memo(AmbassadorsGrid);
